import React, { useState, useEffect, useRef } from "react";
import ApprovalDropDown from "./ApprovalDropDown";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import Toolbar from '../Toolbar';
import Sidebar from '../Sidebar';
import { useNavigate } from 'react-router-dom';
import { PendingApprovalAPI } from '../../axios';

const PendingApprovalMain = () => {
  const [wastes, setWastes] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [sortOrder, setSortOrder] = useState('desc');
  const wastesPerPage = 5;
  const pagesToShow = 5;
  const dropdownRefs = useRef({});
  const navigate = useNavigate();

  useEffect(() => {
    PendingApprovalAPI.fetch_wastes(currentPage, wastesPerPage, sortOrder)
      .then((res) => {
        if (res.code === 200) {
          setWastes(res.data.wastes);
          setTotalPages(Math.ceil(res.data.total / wastesPerPage));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, [currentPage, wastesPerPage, sortOrder]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const dropdownElements = Object.values(dropdownRefs.current);
      if (dropdownElements.every(ref => ref && !ref.contains(event.target))) {
        setOpenDropdownId(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleAction = async (actionType, imageUrl, waste) => {
    if (actionType === 'View') {
      navigate(`/pending-approval/${waste._id}`, {
        state: { imageUrl, waste }
      });
    }
  };

  const handleSort = (sortOrder) => {
    setSortOrder(sortOrder);
  }

  const handleDropdownToggle = (id) => {
    setOpenDropdownId(openDropdownId === id ? null : id);
  };

  const indexOfLastWaste = currentPage * wastesPerPage;
  const indexOfFirstWaste = indexOfLastWaste - wastesPerPage;

  const startPage = Math.max(1, currentPage - Math.floor(pagesToShow / 2));
  const endPage = Math.min(totalPages, startPage + pagesToShow - 1);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const handlePrevSet = () => setCurrentPage((prev) => Math.max(1, prev - pagesToShow));
  const handleNextSet = () => setCurrentPage((prev) => Math.min(totalPages, prev + pagesToShow));

  return (
    <>
      <div className="main-container">
        <Toolbar />
        <Sidebar />
        <div className="content-container">
          <div className="main-content">
            <div className="management-header">
              <h3>Pending Approval</h3>
              <div className="sort-buttons">
                <button onClick={() => handleSort('asc')}>Sort Ascending</button>
                <button onClick={() => handleSort('desc')}>Sort Descending</button>
              </div>
            </div>
            <div className='manage-users'>
              <span>Date</span>
              <span>Phone No</span>
              <name>Name</name>
              <span>Country</span>
              <span>Action</span>
            </div>
            {wastes.map(waste => (
              <div className='manage-users' key={waste._id}>
                <span>{waste.date ? waste.date.split(' ')[0] : 'N/A'}</span>
                <span>{waste.phone_number ? waste.phone_number : 'N/A'}</span>
                <span> {waste.full_name ? waste.full_name : 'N/A'} </span>
                <span>{waste.country ? waste.country : 'N/A'}</span>
                <ApprovalDropDown
                  onActionChange={handleAction}
                  waste={waste}
                  imageUrl={waste.image_path}
                  isOpen={openDropdownId === waste._id}
                  onToggle={() => handleDropdownToggle(waste._id)}
                  ref={(el) => (dropdownRefs.current[waste._id] = el)}
                />
              </div>
            ))}

            <div className='pagination'>
              {startPage > 1 && (
                <button onClick={handlePrevSet} style={{ borderRadius: '3px', display: 'flex' }}>
                  <ArrowBackIosNewIcon />
                </button>
              )}

              {Array.from({ length: endPage - startPage + 1 }, (_, i) => (
                <button
                  key={startPage + i}
                  onClick={() => paginate(startPage + i)}
                  className={currentPage === startPage + i ? 'active' : ''}
                >
                  {startPage + i}
                </button>
              ))}

              {endPage < totalPages && (
                <button onClick={handleNextSet} style={{ borderRadius: '3px', display: 'flex' }}>
                  <ArrowForwardIosIcon />
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PendingApprovalMain;
